import { useState } from "react";
import { Container, Span, InputContain, Divider, IRow } from "../GodMode";
import Button from "../../Generic/Button";
import InputBox from "../../Generic/InputBox";
import { errorNotification } from "../../Generic/Notifications";

const LoadCellTasks = {
	GET_WEIGHT: "GET_WEIGHT",
	TARE: "TARE",
	CHECK_WEIGHT_IN_RANGE: "CHECK_WEIGHT_IN_RANGE",
	TRACK_WEIGHT: "TRACK_WEIGHT",
	INIT_LOADCELL: "INIT_LOADCELL",
};

const LOADCELL_TASKS_CONFIG = {
	[LoadCellTasks.GET_WEIGHT]: {
		taskType: "get_load_cell_weight",
		name: "Get Weight",
	},
	[LoadCellTasks.TARE]: {
		taskType: "tare",
		name: "Tare",
	},
	[LoadCellTasks.CHECK_WEIGHT_IN_RANGE]: {
		taskType: "check_weight_in_range",
		name: "Get Weight",
	},
	[LoadCellTasks.INIT_LOADCELL]: {
		taskType: "init_loadcell",
		name: "Init Loadcell",
	},
	[LoadCellTasks.TRACK_WEIGHT]: {
		taskType: "send_load_weight",
		name: "Track Weight",
	},
};

const LoadCell = ({ sendTask, loadingStates }) => {
	const getWeightLoading = loadingStates[LOADCELL_TASKS_CONFIG[LoadCellTasks.GET_WEIGHT].taskType] || false;
	const tareLoading = loadingStates[LOADCELL_TASKS_CONFIG[LoadCellTasks.TARE].taskType] || false;
	const checkWeightInRangeLoading = loadingStates[LOADCELL_TASKS_CONFIG[LoadCellTasks.CHECK_WEIGHT_IN_RANGE].taskType] || false;
	const initLoadCellLoading = loadingStates[LOADCELL_TASKS_CONFIG[LoadCellTasks.INIT_LOADCELL].taskType] || false;
	const trackWeightLoading = loadingStates[LOADCELL_TASKS_CONFIG[LoadCellTasks.TRACK_WEIGHT].taskType] || false;
	const [trackWeightAmount, setTrackWeightAmount] = useState(0);
	const [checkWeightMinAmount, setCheckWeightMinAmount] = useState(0);
	const [checkWeightMaxAmount, setCheckWeightMaxAmount] = useState(0);

	const handleTare = async () => {
		await sendTask(LOADCELL_TASKS_CONFIG[LoadCellTasks.TARE], {});
	};

	const handleInitLoadCell = async () => {
		await sendTask(LOADCELL_TASKS_CONFIG[LoadCellTasks.INIT_LOADCELL], {});
	};

	const handleGetWeight = async () => {
		await sendTask(LOADCELL_TASKS_CONFIG[LoadCellTasks.GET_WEIGHT], {});
	};

	const handleTrackWeight = async () => {
		if (!trackWeightAmount || isNaN(trackWeightAmount)) {
			errorNotification("Track Weight Amount missing");
			return;
		}
		await sendTask(LOADCELL_TASKS_CONFIG[LoadCellTasks.TRACK_WEIGHT], { amount: trackWeightAmount }, () => {
			setTrackWeightAmount(0);
		});
	};

    const handleCheckWeightInRange = async () => {
        if(isNaN(checkWeightMinAmount)) {
            errorNotification("No minimum amount provided");
            return;
        }
        if(!checkWeightMaxAmount || isNaN(checkWeightMaxAmount)) {
            errorNotification("No maximum amount provided");
            return;
        }
        await sendTask(LOADCELL_TASKS_CONFIG[LoadCellTasks.CHECK_WEIGHT_IN_RANGE], { min: checkWeightMinAmount, max: checkWeightMaxAmount },  () => {
			setCheckWeightMinAmount(0);
			setCheckWeightMaxAmount(0);
		});
    }

	return (
		<Container>
			<Container>
				<Button onClick={handleTare} disabled={tareLoading}>
					Tare
				</Button>
				<Button onClick={handleInitLoadCell} disabled={initLoadCellLoading}>
					Init LoadCell
				</Button>
				<Button onClick={handleGetWeight} disabled={getWeightLoading}>
					Get Weight
				</Button>
			</Container>
			<Divider />
			<IRow>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						Track Weight Amount
					</Span>
					<InputBox
						defaultValue={trackWeightAmount}
						disabled={trackWeightLoading}
						onChange={(e) => {
							setTrackWeightAmount(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleTrackWeight} disabled={trackWeightLoading}>
					Send
				</Button>
			</IRow>
			<Divider />
			<IRow>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						Min Amount
					</Span>
					<InputBox
						defaultValue={checkWeightMinAmount}
						disabled={checkWeightInRangeLoading}
						onChange={(e) => {
							setCheckWeightMinAmount(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						Max Amount
					</Span>
					<InputBox
						defaultValue={checkWeightMaxAmount}
						disabled={checkWeightInRangeLoading}
						onChange={(e) => {
							setCheckWeightMaxAmount(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleCheckWeightInRange} disabled={checkWeightInRangeLoading}>
					Check Weight In Range
				</Button>
			</IRow>
		</Container>
	);
};

export default LoadCell;
